import { render, staticRenderFns } from "./ConsejoSection.vue?vue&type=template&id=72a809aa&scoped=true&"
import script from "./ConsejoSection.vue?vue&type=script&lang=js&"
export * from "./ConsejoSection.vue?vue&type=script&lang=js&"
import style0 from "./ConsejoSection.vue?vue&type=style&index=0&id=72a809aa&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "72a809aa",
  null
  
)

export default component.exports